export enum Project {
  PC = 'pc',
  MOBILE = 'mobile',
}
